import styles from './NoteName.module.css';

interface INoteNameProps {
  children: string;

  onClick(): void;
}

export function NoteName({ children, onClick }: INoteNameProps) {
  return (
    // Печать из браузера прячет имя через @media print в NoteName.module.css.
    // Экспорты в docx и pdf собираются из данных и DOM не читают, поэтому
    // помечать элемент для них больше не нужно.
    <div className={styles['note-name']} onClick={onClick}>
      {children}
    </div>
  );
}
